import { Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { StepKeys } from '../..'
import { useStyles } from './styles'

export interface ConcludedStepProps {
  onChangeCurrentStep: (step: StepKeys) => void
}

export function ConcludedStep({ onChangeCurrentStep }: ConcludedStepProps) {
  const classes = useStyles()

  function handleCancel() {
    onChangeCurrentStep('activity_type')
  }

  return (
    <div className={classes.container}>
      <Typography variant='h1'>Atividade Cadastrada</Typography>

      <section>
        <CheckCircleIcon />
        <Typography variant={'h2'}>Cadastro finalizado</Typography>
        <Typography variant={'h2'}>
          Atividade disponível no calendário de atividades
        </Typography>
      </section>

      <div className={classes.inputsContainer}>
        <div className={classes.buttonsContainer}>
          <Button outlined onClick={handleCancel}>
            Agendar nova atividade
          </Button>
          <Button component={Link} to={routes.Activities()}>
            Ver calendário
          </Button>
        </div>
      </div>
    </div>
  )
}
